module.exports = __webpack_public_path__ + "img/ClockIcon.a6ab8ded.svg";